import { snapdom } from "@zumer/snapdom";

import { IScreenshotSettings } from "models/screenshot";

import legendTitleWidthPlugin from "components/screenshot/plugins/legendTitleWidthPlugin";
import virtuosoScrollPlugin from "components/screenshot/plugins/virtuosoScrollPlugin";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const copyMapToClipboard = async (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  widgetState: any,
  settings: IScreenshotSettings
): Promise<Blob> => {
  if (!widgetState?.mapbox) {
    return;
  }
  const mapbox = widgetState.mapbox;
  const canvas = mapbox.getCanvas();
  if (!canvas) return;
  const parentRect = canvas.getBoundingClientRect();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const el: any = widgetState?.copyOverlay;
  const boundingRect = el.getBoundingClientRect();

  const scale = window.devicePixelRatio;
  const mapScreenshotScale = settings.mapScreenshotScale ?? 1;
  const width = Math.floor(scale * Number(boundingRect?.width));
  const height = Math.floor(scale * Number(boundingRect?.height));
  const x = Math.floor(scale * (boundingRect.left - parentRect.left));
  const y = Math.floor(scale * (boundingRect.top - parentRect.top));

  // Crop the map region directly via drawImage source rect — keeps pixel data
  // on the GPU and avoids the expensive getImageData/putImageData round-trip.
  let offscreenCanvas = document.createElement("canvas");
  offscreenCanvas.width = width;
  offscreenCanvas.height = height;
  let offscreenCtx = offscreenCanvas.getContext("2d");
  offscreenCtx?.drawImage(canvas, x, y, width, height, 0, 0, width, height);

  // Scale map
  if (mapScreenshotScale !== 1) {
    const desiredWidth = Math.floor(Number(settings?.width) * scale);
    const desiredHeight = Math.floor(Number(settings?.height) * scale);
    const resizedCanvas = document.createElement("canvas");
    resizedCanvas.width = desiredWidth;
    resizedCanvas.height = desiredHeight;
    const resizedCtx = resizedCanvas.getContext("2d");
    resizedCtx.imageSmoothingEnabled = true;
    resizedCtx.imageSmoothingQuality = "high";

    resizedCtx.drawImage(
      offscreenCanvas,
      0,
      0,
      width,
      height,
      0,
      0,
      desiredWidth,
      desiredHeight
    );

    offscreenCanvas = resizedCanvas;
    offscreenCtx = resizedCtx;
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  const legendContainer: HTMLElement = document.getElementsByClassName("copy-overlay")[0];
  legendContainer.style.background = "transparent";
  legendContainer.style.border = "none";
  legendContainer.style.outline = "none";
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  legendContainer.getElementsByClassName("buttons")[0].style.display = "none";

  // Convert copy overlay into canvas and overlay it on top of map.
  const reverseScale = 1 / mapScreenshotScale;
  const legendCanvas = await snapdom.toCanvas(legendContainer, {
    scale: reverseScale,
    embedFonts: true,
    plugins: [virtuosoScrollPlugin, legendTitleWidthPlugin]
  });

  offscreenCtx?.drawImage(legendCanvas, 0, 0);

  return await new Promise<Blob | null>((resolve) => offscreenCanvas.toBlob(resolve));
};
